import React, { useEffect, useState } from 'react';
import {
  Link,
  Outlet,
  useMatches,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';
import _ from "lodash";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Fade from "@mui/material/Fade";

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import StepLabel from '@mui/material/StepLabel';

import RegisterForm from '../components/RegisterForm';
import MessagesForm from '../components/MessagesForm';
import ReviewForm from '../components/ReviewForm';

import Invoice from '../components/Invoice';
import PaymentSummary from '../components/PaymentSummary';

import useUser from '../hooks/useUser';
import useToken from '../hooks/useToken';
import RegisterAction from '../actions/RegisterAction';
import updateSaasticAccountAction from '../actions/updateSaasticAccountAction';

import { 
  HiOutlineChevronLeft,
  HiOutlineChevronRight
} from "react-icons/hi";

import '../App.css';

export default function Register() {
  const { user, setUser } = useUser();
  const { token, setToken } = useToken();
  const navigate = useNavigate();
  const routerMatches = useMatches();
  const [step, setStep] = useState(0);

  /*  Navigation */
  const pageName = () => {
    let page = routerMatches[routerMatches.length-1]['pathname'].split('/').reverse().find((val) => val !== "" && isNaN(val))
    return page;
  }

  useEffect(() => {
    if (pageName() === "register" || pageName() === inviteCode) navigate("/register/step_1", { replace: true });
  }, [pageName]);  

  const steps = [
    'step_1',
    'step_2',
    'step_3',
    'confirm',
  ]  

  const navigateToTab = (eventKey, e) => {
    if (e) e.preventDefault();
    if (eventKey === 'next') {
      if (!validate(step)) {
        alert('Please complete all required fields before continuing.');
        return;
      }
      if (step == 0) {
        /*  Register */      
        register({email, password, businessName, inviteCode});
      } else {
        /*  Update Saastic */      
        console.log('update')
        console.log(newToken)

        updateSaastic(newToken, {requestSubject, requestBody, reminderSubject, reminderBody, thanksPositiveSubject, thanksPositiveBody, thanksNegativeSubject, thanksNegativeBody, formTitle, formBody, yelpLink, googleLink});
      }

    } else if (eventKey === 'back') {
      if (step == 0) {
        navigate("/register/"+steps[0]);
        //navigate("/i/"+inviteIdCode);
        setStep(0);
      } else {
        navigate("/register/"+steps[step-1]);
        setStep(step-1);
      }
    } else {
      if (typeof(eventKey) == 'undefined' || eventKey == 'undefined') navigate("/register/"+steps[0]);
      navigate("/register/"+eventKey);
      setStep(steps.indexOf(eventKey));
    } 
  }

  /*  State for each tab */
  // tab 1
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [businessName, setBusinessName] = useState();
  const [inviteCode, setInviteCode] = useState();
  const [newToken, setNewToken] = useState(token); // kludge
  // tab 2
  const [requestSubject, setRequestSubject] = useState('We need your feedback');
  const [requestBody, setRequestBody] = useState('Hi {{first_name}}, thanks for your business! We would love to know what you think. Please rate and review our service.');
  const [reminderSubject, setReminderSubject] = useState('Your feedback is important to us');
  const [reminderBody, setReminderBody] = useState('Hi {{first_name}}, thanks for your business! We would love to know what you think. Please rate and review our service.');
  const [thanksPositiveSubject, setThanksPositiveSubject] = useState('Thanks for your feedback!');
  const [thanksPositiveBody, setThanksPositiveBody] = useState('Hi {{first_name}}, thanks for your feedback! We appreciate your business.');
  const [thanksNegativeSubject, setThanksNegativeSubject] = useState('Thanks for your feedback!');
  const [thanksNegativeBody, setThanksNegativeBody] = useState('Hi {{first_name}}, thanks for your feedback! We appreciate your business.');
  // tab 3
  const [formTitle, setFormTitle] = useState('How did we do?');
  const [formBody, setFormBody] = useState('Your feedback means a lot to us.\nPlease rate and review our service.');
  const [yelpLink, setYelpLink] = useState();
  const [googleLink, setGoogleLink] = useState();
  
  /*  Validation */
  const validate = (step) => {
    if (step === 0) {
      if (!email || !password || !businessName) return false;
    }
    if (step === 1) {
      if (!requestSubject || !requestBody || !reminderSubject || !reminderBody || !thanksPositiveSubject || !thanksPositiveBody || !thanksNegativeSubject || !thanksNegativeBody) return false;
    }
    if (step === 2) {
      if (!formTitle || !formBody) return false;
    }
    return true;
  }

  const register = async (args) => {
    const response = await RegisterAction(args);
    if(response.success) {
      if(!!response.data) {
        setToken(response.data.token);
        setUser(response.data);
        setNewToken(response.data.token)
        navigate("/register/"+steps[step+1]);
        setStep(step+1);      
      } else {
        window.confirm('Error getting auth token. Try logging in with the email and password you entered.');
        navigate("/");
      }
    } else {
      alert('Could not complete registration.');
    }
  }

  const updateSaastic = async (token, args) => {
        console.log('update2')

    const response = await updateSaasticAccountAction(token, args);
    if(response.success) {
      navigate("/register/"+steps[step+1]);
      setStep(step+1);
    } else {
      alert('Could not save changes.');
    }
  }

  const handleChange = (name, value) => {
    const setState = eval('set'+_.upperFirst(name));
    setState(value)
  };

  return (
    <>
      <Container fluid className="mb-0">
        <Row>
          <Col>
            <Stepper activeStep={steps.indexOf(pageName())} >
              {steps.map((name, index) => {
                return (
                  <Step key={name}>
                    <StepLabel />
                  </Step>
                );
              })}
            </Stepper>
          </Col>
        </Row>       
      </Container>

      {pageName() === 'step_1' &&
        <>
          <h2 className="px-3 my-3 text-sm-start text-md-center">Registration</h2>
          <Container fluid className="my-0">
            <Row>
              <Col>
                <p>
                  Try us out for free!<br/>
                  No payment info required.
                </p>
              </Col>
            </Row>          
            <Row>
              <Col>
                <RegisterForm 
                  handleChange={handleChange} 
                  email={email}
                  password={password}
                  businessName={businessName}
                  inviteCode={inviteCode}
                />
              </Col>
            </Row>
          </Container>     
        </>
      }

      {pageName() === 'step_2' &&
        <>
          <h2 className="px-3 my-3 text-sm-start text-md-center">Email Messages</h2>
          <Container fluid className="my-0">
            <Row>
              <Col>
                <p>
                  You can customize the messages that we send to your customers. You can edit these later, too.
                </p>
              </Col>
            </Row>          
            <Row>
              <Col>
                <MessagesForm 
                  handleChange={handleChange} 
                />
              </Col>
            </Row>
          </Container>        
        </>
      }

      {pageName() === 'step_3' &&
        <>
          <h2 className="px-3 my-3 text-sm-start text-md-center">Reviews</h2>
          <Container fluid className="my-0">
            <Row>
              <Col/>
              <Col xs={12} sm={8} md={6}>
                <p>
                  You can customize the form where customers leave feedback. Add the links to your Yelp and Google page if you'd like to prompt customers to leave reviews there as well. 
                </p>
              </Col>
              <Col/>
            </Row>          
            <Row>
              <Col>
                <ReviewForm 
                  handleChange={handleChange} 
                />
              </Col>
            </Row>
          </Container>        
        </>
      }

      {pageName() === 'confirm' &&
        <>
          <h2 className="px-3 my-3 text-sm-start text-md-center">Registration Complete</h2>
          <Container fluid className="my-0">
            <Row>
              <Col/>
              <Col xs={12} sm={8} md={6}>
                <p>
                  Your account is being provisioned. It will be operational within one business day. We'll email you when it's ready.  
                </p>
              </Col>
              <Col/>
            </Row>          
            <Row>
              <Col>
                  <Button onClick={() => navigate("/merchant/dashboard/")} variant="primary">
                    Go to Dashboard
                  </Button>
              </Col>
            </Row>
          </Container>        
        </>
      }

      {pageName() !== 'confirm' &&
        <Container fluid className="px-sm-3 my-3">
          <Row className="mb-5">
          {'' && 
          <>
            <Col className="text-start">
              <Button className="" variant="primary" onClick={(e) => navigateToTab('back')} disabled={step == 0} ><HiOutlineChevronLeft className="icon" /> Back</Button>
            </Col>
            <Col className="text-end">
              <Button className="" variant="primary" onClick={(e) => navigateToTab('next')} >Next <HiOutlineChevronRight className="icon" /></Button>
            </Col>
          </>
          }
            <Col/>
            <Col xs={12} sm={8} md={6}>
              <Button className="" variant="primary" onClick={(e) => navigateToTab('next')} >Next <HiOutlineChevronRight className="icon" /></Button>
            </Col>          
            <Col/>
          </Row>
        </Container>
      }

    </>
  );

  

}


